export default {
  titleFontSize: '22px'
}
